// Image src
// Size in Shopify format (1200x for instance)
// Replace the current sixe if already in image src for instance myimage_300x.jpg?v=1606764383 becomes myimage_1200x.jpg?v=1606764383
const getSizedImageURL = (src, size, replace_current_size = false) => {
  if (typeof src === 'undefined') {
    return null;
  }

  if (size === null || size === 'master') {
    return src;
  }

  const match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
  if (match) {
    let prefix = src.split(match[0])[0];
    const suffix = match[0];

    if (replace_current_size) {
      const prefix_parts = prefix.split('_');
      // case 2024Resort_69.jpg?v=1713317805 where _69 is not a size
      if (prefix_parts.length > 1 && prefix_parts[prefix_parts.length - 1].includes('x')) {
        prefix = prefix.replace(`_${prefix_parts[prefix_parts.length - 1]}`, '');
      }
    }

    return `${prefix}_${size}${suffix}`;
  }

  return null;
};

const preloadImage = (url, singleImageLoadedCallback) => {
  const img = new Image();
  img.onload = singleImageLoadedCallback;
  img.src = url;
};

const preloadImages = (urls, allImagesLoadedCallback) => {
  let loaded_counter = 0;
  const to_be_loaded_number = urls.length;

  urls.forEach((url) => {
    preloadImage(url, () => {
      loaded_counter++;
      // console.log(`Loaded: ${loaded_counter} => ${url}`);

      if (loaded_counter === to_be_loaded_number) {
        allImagesLoadedCallback();
      }
    });
  });
};

/*
const progressiveJpg = (src) => {
  if (src.includes('.progressive.')) {
    return src;
  }

  const file_extension = _.first(_.last(src.split('.')).split('?'));
  let new_src = src;

  if (file_extension.toLowerCase() === 'jpg' || file_extension.toLowerCase() === 'jpeg') {
    new_src = src.replace(file_extension, `progressive.${file_extension}`);
  }

  return new_src;
};
*/

// Use ImageKit (Imgix not supported at the moment since we decided to move away from it)
const optimizeImage = (src) => {
  if (window.theme.imageOptimization.service !== 'imagekit') {
    return src;
  }

  // Assuming there's only 1 shopify_cdn defined
  return src.replace(window.theme.imageOptimization.shopify_cdn[0], window.theme.imageOptimization.service_url);
};

export {
  getSizedImageURL,
  preloadImages,
  // progressiveJpg,
};
